<template>
  <b-container fluid>
    <backlink/>
    <h1>Pièces de rechange</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "SparePartList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {};
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SparePart/SparePartList.vue